module.exports = __webpack_public_path__ + "img/banner3.a1233b0b.png";